import { types as t, Instance } from 'mobx-state-tree';
import BaseConfiguration from './base';
import { ReportPerimeterStandardsTypes } from '../types';

const ReportConfigurationModel = t.compose(
  t.model({
    node_ids: t.maybeNull(t.array(t.frozen())),
    wind_manual_node_ids: t.maybeNull(t.array(t.frozen())),
    parameters: t.array(t.frozen()),
    wind_speed: t.maybeNull(t.string),
    wind_direction: t.maybeNull(t.string),
    wind_detection: t.maybeNull(t.optional(t.enumeration('WindDetection', ['auto', 'manual']), 'auto')),
    floor_negative_deltas: t.maybeNull(t.boolean),
    // Reports created before standards were introduced have no standard and use custom parameters
    standard: t.optional(t.maybeNull(t.string), ReportPerimeterStandardsTypes.custom)
  }),
  BaseConfiguration
);

export interface IReportConfigurationModel extends Instance<typeof ReportConfigurationModel> {}

export default ReportConfigurationModel;
